module.exports = __webpack_public_path__ + "img/air-3.a601bbab.jpeg";